<template>
    <div>
        <el-row class="bottom20">
            <el-table :data="tableData" highlight-current-row>
                <el-table-column prop="name" label="姓名">
                    <template slot="header" slot-scope="scope">
                        姓名<br>
                        <el-input size="mini" class="width70" v-model="searchParams.name">
                        </el-input>
                    </template>
                    <template slot-scope="scope">
                        <el-button @click="queryDetail(scope.row.id)" type="text" size="mini">
                            {{ scope.row.name }}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="idno" label="证件号">
                    <template slot="header" slot-scope="scope">
                        证件号<br>
                        <el-input size="mini" class="width70"
                                  v-model="searchParams.idno">
                        </el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="deptid" label="数据中心" :formatter="formatDept">
                    <template slot="header" slot-scope="scope">
                        数据中心<br>
                        <dept-select size="mini" ref="deptRef" v-model="searchParams.deptid" @fetchAllDepts="fetchAllDepts">
                        </dept-select>
                    </template>
                </el-table-column>
                <el-table-column prop="imgName" label="附件">
                    <template slot="header" slot-scope="scope">
                        附件<br><br><br>
                    </template>
                </el-table-column>
                <el-table-column prop="enterDate" :formatter="formatDate" label="上传时间">
                    <template slot="header" slot-scope="scope">
                        上传时间<br><br><br>
                    </template>
                </el-table-column>
                <el-table-column prop="startDate" :formatter="formatDate" label="签字有效起始时间">
                    <template slot="header" slot-scope="scope">
                        签字有效起始时间<br><br><br>
                    </template>
                </el-table-column>
                <el-table-column prop="endDate" :formatter="formatDate" label="签字有效截止时间">
                    <template slot="header" slot-scope="scope">
                        签字有效截止时间<br><br><br>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>

        <el-row type="flex" class="row-bg" justify="end">
            <el-pagination align="right" @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="currentPage"
                           :page-sizes="pageSizes" :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </el-row>

    </div>
</template>

<script>

import DeptSelect from '@/components/dept'
import RegisterServer from "../../../api/register";
import {debounce} from "../../../util";
import AttachmentServer from "../../../api/attachment";

export default {
    name: "signRecordPage",

    components: {
        DeptSelect,
    },

    data() {
        return {

            //表格翻页查询条件
            currentPage: 1,
            pageSize: 10,
            pageSizes: [10, 25, 50, 100],
            total: 0,

            searchParams: {
                deptid: null,
                idno: null,
                name: '',
            },

            tableData: [],

            deptMap: new Map(),
        }
    },

    methods: {
        async queryTable() {
            if (this.searchParams.deptid == null || this.searchParams.deptid == '') {
                return;
            }
            let pageParams = {
                'currentPage': this.currentPage,
                'pageSize': this.pageSize,
            }
            let params = {...this.searchParams, ...pageParams};
            let tableDataCopy = [];
            await RegisterServer.signRecord.page(params).then(res => {
                tableDataCopy = res.data.data.pageData;
                this.total = res.data.data.total;
            });

            //获取附件名称
            let imgIds = tableDataCopy.map(e => e.id);
            let imgPromiseArr = [];
            for (let i = 0; i < imgIds.length; i++) {
                let promiseTmp = AttachmentServer.attachment.downloadList({
                    'ownerTable': 'REGSIGNRECORD',
                    'ownerId': imgIds[i],
                });
                imgPromiseArr.push(promiseTmp);
            }
            await Promise.all(imgPromiseArr).then(res => {
                for (let i = 0; i < res.length; i++) {
                    tableDataCopy[i].imgName = res[i][0].name;
                }
            });

            this.tableData = tableDataCopy;
        },

        handleSizeChange(val) {
            this.pageSize = val;
        },
        handleCurrentChange(val) {
            this.currentPage = val;
        },

        formatDept(row, column) {
            let deptDesc = '';
            this.$refs.deptRef.deptList.forEach(e => {
                if (row[column.property] == e.id) {
                    deptDesc = e.name;
                }
            });
            return deptDesc;
        },

        fetchAllDepts(value) {
            if (value != null && value.length > 0) {
                this.searchParams.deptid = value[0].id;
            }
        },

        queryDetail(id) {
            this.$emit('queryDetail', id);
        },

        formatDate(row, column){
            return new Date(row[column.property]).Format('yyyy-MM-dd hh:mm:ss');
        },
    },

    mounted() {
        this.queryTable();
    },

    watch: {
        searchParams: {
            deep: true,
            handler: debounce(function (newVal, oldVal) {
                this.currentPage = 1;
                this.total = 0;
                this.tableData = [];
                this.queryTable();
            }, 500)
        },

        pageSize: {
            handler() {
                this.queryTable();
            },
        },

        currentPage: {
            handler() {
                this.queryTable();
            },
        },
    },
}
</script>

<style scoped>

</style>